"use client";
import React from "react";

export const StatCard = ({ title, value, trend, icon }) => {
  const trendColor = trend >= 0 ? "text-green-500" : "text-red-500";
  const trendIcon = trend >= 0 ? "↑" : "↓";

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h3 className="text-gray-500 text-sm font-medium mb-2">{title}</h3>
          <p className="text-2xl font-semibold text-gray-700">{value}</p>
        </div>
        <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
          {icon}
        </div>
      </div>
      {trend !== undefined && (
        <div className="mt-4 flex items-center gap-2">
          <span className={`${trendColor} text-sm font-medium`}>
            {trendIcon} {Math.abs(trend)}%
          </span>
          <span className="text-gray-500 text-sm">vs last month</span>
        </div>
      )}
    </div>
  );
};
